module.exports = __webpack_public_path__ + "static/hero-fc0b3c211c0d8d2c17ade75f33ce93a9.jpg";